import { useRef, useLayoutEffect } from 'react'
import PropTypes from 'prop-types'
import styles from './Tabs.module.css'

export function Tabs({ items, value, onChange, className = '' }) {
  const tabRefs = useRef({})
  const indicatorRef = useRef(null)
  const hasMountedRef = useRef(false)

  useLayoutEffect(() => {
    const activeTab = tabRefs.current[value]
    const indicator = indicatorRef.current
    if (!activeTab || !indicator) return

    if (!hasMountedRef.current) {
      indicator.style.transition = 'none'
    }

    indicator.style.width = `${activeTab.offsetWidth}px`
    indicator.style.height = `${activeTab.offsetHeight}px`
    indicator.style.transform = `translateX(${activeTab.offsetLeft}px)`

    if (!hasMountedRef.current) {
      // eslint-disable-next-line no-unused-expressions
      indicator.offsetHeight // fuerza reflow antes de restaurar la transicion
      indicator.style.transition = ''
      hasMountedRef.current = true
    }
  }, [value, items])

  return (
    <div className={[styles.tabs, className].filter(Boolean).join(' ')} role="tablist">
      <div ref={indicatorRef} className={styles.tabs__indicator} />
      {items.map((item) => (
        <button
          key={item.value}
          ref={(el) => {
            tabRefs.current[item.value] = el
          }}
          type="button"
          role="tab"
          aria-selected={item.value === value}
          className={[styles.tab, item.value === value ? styles['tab--active'] : '']
            .filter(Boolean)
            .join(' ')}
          onClick={() => onChange(item.value)}
        >
          {item.icon && <span className={styles.tab__icon}>{item.icon}</span>}
          {item.label}
        </button>
      ))}
    </div>
  )
}

Tabs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      icon: PropTypes.node,
    })
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
}
